import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { settingsStoreToken } from '../../../../../../../cross-team-shared/state/setting-state';
import { SettingsService } from '../../../../../../h3ml/dsl/sensor-fusion/view-settings/settings.service';
import { shapeProjectionIcon } from '../../../../../../shared/icons/toolbars/shape-projection-icon';

@Component({
  selector: 'h3-toggle-shape-projection-button',
  templateUrl: './toggle-shape-projection-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ToggleShapeProjectionButtonComponent {
  private readonly settingsStore = inject(settingsStoreToken);

  areProjectionsEnabled$ = this.settingsStore('areProjectionsEnabled').$;
  showShapeProjection$ = this.settingsStore('showShapeProjection').$;
  shapeProjectionIcon = shapeProjectionIcon;

  private settingsService = inject(SettingsService);

  toggleProjection() {
    this.settingsService.toggleShowShapeProjection();
  }
}
